import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import i18next from 'i18next';

import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import LanguageIcon from '@mui/icons-material/Language';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import { updateLanguageUser } from 'store/user-actions';

import classes from './UserLanguage.module.css';

const UserLanguage = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector(state => state.userInfo);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [browserLanguage, setbrowserLanguage] = useState('');

  useEffect(() => {
    const userLocale =
      navigator.languages && navigator.languages.length
        ? navigator.languages[0]
        : navigator.language;
    let browserLanguageData = userLocale.split('-');
    setbrowserLanguage(browserLanguageData[0]);
  }, []);

  useEffect(() => {
    if (userInfo.data.usuario.length > 2) {
      i18next.changeLanguage(userInfo.data.idioma);
    } else {
      const userLocale =
        navigator.languages && navigator.languages.length
          ? navigator.languages[0]
          : navigator.language;
      let browserLanguageData = userLocale.split('-');
      setbrowserLanguage(browserLanguageData[0]);
      i18next.changeLanguage(browserLanguageData[0]);
    }
  }, [userInfo]);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeLanguageHandle = lng => () => {
    i18next.changeLanguage(lng);
    setbrowserLanguage(lng);
    dispatch(updateLanguageUser(userInfo.data.usuario, lng));
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        id="language-button"
        aria-controls={open ? 'language-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        className={classes.languageButton}
      >
        <LanguageIcon className={classes.languageIcon} />
        <span className={classes.languageText}>
          {userInfo.data.usuario
            ? userInfo.data.idioma
            : browserLanguage}
        </span>
        <ArrowDropDownIcon />
      </IconButton>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'language-button'
        }}
      >
        <MenuItem onClick={changeLanguageHandle('en')}>
          English
        </MenuItem>
        <MenuItem onClick={changeLanguageHandle('es')}>
          Español
        </MenuItem>
        <MenuItem onClick={changeLanguageHandle('pt')}>
          Português
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserLanguage;
